import { es } from 'date-fns/locale';
import { useTranslation } from 'next-i18next';
import React, { useContext } from 'react';
import DatePicker from 'react-datepicker';
import { registerLocale } from 'react-datepicker';
registerLocale('es', es);

import { PeriodicJobsContext } from '@/modules/periodicJobs/context/context';
import { periodicJobsActionsTypes as ActionsTypes } from '@/modules/periodicJobs/context/reducer';
import { Typography } from '@/shared/components/atoms';
import { getDateFormat } from '@/shared/components/molecules/CustomDatePicker/logic';

import Calender from '~/images/shared/calender.svg';

const RangeDatePicker = () => {
  const {
    state: { endDate, startDate },
    dispatch,
  } = useContext(PeriodicJobsContext);
  const { i18n } = useTranslation('common');

  const { language } = i18n;

  const today = new Date();

  return (
    <div
      className='items-center gap-2 rounded-xl px-7 py-14 tablet:flex'
      style={{ backgroundColor: '#2677D10D' }}
    >
      <div className='flex items-center gap-5'>
        <span className='text-20 text-primary-default'>
          <Calender />
        </span>
      </div>
      <div className='flex items-center'>
        {startDate && (
          <DatePicker
            wrapperClassName='relative'
            locale={language}
            selected={startDate}
            maxDate={endDate}
            onChange={(date) =>
              date
                ? dispatch({ type: ActionsTypes.setStartDate, payload: date })
                : null
            }
            customInput={
              <Typography
                variant='body1'
                weight='bold'
                className='w-fit cursor-pointer px-2 py-2'
              >
                {getDateFormat(startDate, language, 'dd/MM/YYY')}
              </Typography>
            }
          />
        )}
        <span className='text-16 mx-2'>-</span>
        {endDate && (
          <DatePicker
            wrapperClassName='relative'
            locale={language}
            selected={endDate}
            maxDate={today}
            minDate={startDate}
            onChange={(date) =>
              date
                ? dispatch({ type: ActionsTypes.setEndDate, payload: date })
                : null
            }
            customInput={
              <Typography
                variant='body1'
                weight='bold'
                className='w-fit cursor-pointer px-2 py-2'
              >
                {getDateFormat(endDate, language, 'dd/MM/YYY')}
              </Typography>
            }
          />
        )}
      </div>
    </div>
  );
};
export default RangeDatePicker;
